
































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ILiveRedpacket, ILiveRoomItem } from "@/api/types";
import { Dialog, ImagePreview, Toast } from "vant";
import { showDialog } from "@/components/redEnvelope/index";
import request from "@/api/index";
import { needToken } from "@/common/decorator";
import Native from "@/common/Native";
import { isOpenInWechat, openUrl, zoomDom } from "@/common/utils";
@Component
export default class LiveRoomItem extends Vue {
  @Prop()
  item!: ILiveRoomItem;
  isPraise = false;
  isShowMore = false;

  get showCommentList() {
    if (this.isShowMore) {
      return this.item.commentDtoList;
    } else {
      return this.item.commentDtoList.slice(0, 5);
    }
  }

  get imgList() {
    return this.item.imageHyperLink || [];
  }

  get zanIcon() {
    if (this.item.isPraise) {
      return require("../assets/image/聊天点赞（已点赞）@2x.png");
    } else {
      return require("../assets/image/聊天点赞@2x.png");
    }
  }

  get moreButtonText() {
    return this.isShowMore ? "收起更多评论" : "展开更多评论";
  }

  get redEnvelopeName() {
    if (this.item.liveRedpacketDto) {
      return this.item.liveRedpacketDto.type === 1 ? "现金红包" : "积分红包";
    }
    return "";
  }

  mounted() {
    this.$nextTick(() => {
      zoomDom(0.9097, this.$refs.content_text as HTMLElement);
    });
  }

  showMoreComment() {
    this.isShowMore = !this.isShowMore;
  }

  preImages(url = "", isLink = true) {
    let images: string[] = [];
    if (isLink) {
      images = this.imgList
        .filter(item => !item.hyperLink)
        .map(item => item.image);
    } else {
      images = this.imgList.map(item => item.image);
    }
    let index = 0;
    if (url) {
      index = images.findIndex(item => item === url);
    }
    ImagePreview({
      images,
      startPosition: index
    });
  }

  linkClick(url: string) {
    openUrl(url);
  }

  imgClick(item: { image: string; hyperLink: string }) {
    if (item.hyperLink) {
      openUrl(item.hyperLink);
    } else {
      this.preImages(item.image);
    }
  }

  @needToken(true, true)
  async openRedEnvelope() {
    const result = await request.liveRedpacket(
      this.item.id + "",
      this.item.compereName,
      this.item.avatar
    );
    if (result.code === 0 && result.data) {
      if (result.data.redpacketStatus === 2) {
        showDialog
          .open({
            name: this.item.compereName,
            img: this.item.avatar,
            text: this.item.liveRedpacketDto.message,
            type: this.item.liveRedpacketDto.type
          })
          .then(async () => {
            const openResult = await request.openRedpacket(this.item.id + "");
            if (openResult.code === 0 && openResult.data) {
              this.redEnvelopeResult(openResult.data);
            } else if (openResult.code === -101000135) {
              Dialog.confirm({
                message: openResult.message,
                confirmButtonColor: "#49a8ef",
                confirmButtonText: "前往登录"
              })
                .then(() => {
                  Native.goToken(2).then(() => {
                    location.reload();
                  });
                })
                .catch(() => {});
            } else {
              Toast(openResult.message);
            }
          });
      } else {
        this.redEnvelopeResult(result.data);
      }
    } else {
      Toast(result.message);
    }
  }

  redEnvelopeResult(item: ILiveRedpacket) {
    switch (item.redpacketStatus) {
      case 1:
        showDialog.success({
          code: item.code,
          codeStatus: item.awardStatus,
          sum: item.quota,
          type: item.type,
          wechatName: item.accName
        });
        break;
      case 3:
        showDialog.fail({ text: "晚来一步<br/>红包已经发完了" });
        break;
      case 4:
        showDialog.fail({ text: "晚来一步<br/>红包已经过期了" });
        break;
    }
  }

  @needToken(false)
  async doPraise() {
    // 是否登录
    if (this.$store.state.token) {
      if (this.item.isPraise) return;
      const result = await request.doPraise(
        "",
        this.$store.state.detail!.title,
        this.item.id + "",
        0,
        80
      );
      if (result.data) {
        this.$emit("do-praise", this.item.id, 1);
      } else {
        Toast(result.message);
      }
    } else {
      const result = await request.doPraiseShare(
        this.item.id + "",
        this.$store.state.detail!.title,
        80
      );
      if (result.code === 0) {
        this.$emit("do-praise", this.item.id, 1);
      } else {
        Toast(result.message);
      }
    }
  }

  /** 评论 */
  @needToken(true)
  comment() {
    if (isOpenInWechat()) {
      this.$emit("showcommentfun", {
        sourceType: this.item.sourceType,
        sourceId: this.item.id + "",
        passiveReplyName: this.item.compereName,
        passiveReplyId: this.item.compereId + ""
      });
      return;
    }
    Native.openComment({
      sourceType: this.item.sourceType,
      id: this.item.id + "",
      replyId: "",
      passiveReplyName: this.item.compereName,
      passiveReplyId: this.item.compereId + ""
    });
  }
}
